/** Indicates which point on a positioned element it should be positioned by. */
export enum PositionAnchor {
    TOP_LEFT = "top left",
    TOP_RIGHT = "top right",
    BOTTOM_LEFT = "bottom left",
    BOTTOM_RIGHT = "bottom right"
}
